var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAssignPending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58,
    height: 75,
    viewBox: "0 0 58 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a47o0xazma",
    d: "M0 0.686L56.933 0.686 56.933 72.291 0 72.291z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.885 .5) translate(0 .023)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "iyj9uny3jb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a47o0xazma"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F6BF00",
    d: "M46.477 48.601C34.31 67.202 16.37 76.86 6.43 70.171c-9.952-6.681-8.154-27.19 4.024-45.793C22.63 5.783 40.562-3.882 50.502 2.806c9.953 6.683 8.156 27.188-4.025 45.795",
    mask: "url(#iyj9uny3jb)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1A171B",
    d: "M26.943 46.6c0 1.848-1.497 3.348-3.343 3.348-1.846 0-3.345-1.5-3.345-3.347 0-1.848 1.499-3.346 3.345-3.346s3.343 1.498 3.343 3.346",
    transform: "translate(.885 .5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M37.15 41.493c.008-.01.017-.017.027-.025.007-.01.017-.02.023-.027l1.229-1.254-6.491-1.985 2.085 6.46 3.127-3.17zm5.15 7.096c-.225.224-.52.333-.813.333-.298 0-.596-.113-.823-.342l-3.634-3.675-2.043 2.068c-.069.07-.146.132-.23.182-.37.22-.726.33-1.067.33-.185 0-.365-.033-.54-.1-.76-.285-1.003-1.029-1.18-1.57l-.099-.297-2.813-8.7c-.138-.411-.035-.864.267-1.174.302-.31.749-.426 1.167-.3l8.727 2.669c.14.046.24.077.34.107.54.168 1.283.399 1.58 1.154.194.49.124 1.032-.206 1.609-.048.085-.108.163-.177.233l-1.904 1.944-.029.027c-.008.011-.018.018-.026.03l-.144.145 3.655 3.692c.449.455.445 1.187-.009 1.635zM28.498 28.17c0-.704-.196-1.35-.599-1.973-.417-.648-.967-1.148-1.684-1.53-.72-.388-1.476-.575-2.309-.575-.831 0-1.587.187-2.308.574-.716.383-1.266.885-1.684 1.529-.402.625-.6 1.27-.6 1.975 0 1.48.44 2.677 1.343 3.652.878.953 1.94 1.415 3.249 1.415 1.308 0 2.373-.462 3.25-1.415.902-.975 1.342-2.171 1.342-3.652zm2.284 0c0 2.053-.655 3.802-1.946 5.202-1.317 1.426-2.976 2.149-4.93 2.149-1.953 0-3.611-.723-4.927-2.147-1.293-1.401-1.947-3.15-1.947-5.204 0-1.142.323-2.223.962-3.212.624-.967 1.474-1.743 2.526-2.306 2.088-1.12 4.684-1.12 6.773 0 1.052.563 1.902 1.34 2.526 2.306.639.989.963 2.07.963 3.212zm-4.387 12.66c-2.64-.227-5.523-.136-8.09.565-3.399.927-4.612 4.033-4.703 7.336-.04 1.488-2.353 1.49-2.312 0 .096-3.454 1.323-7.43 4.7-8.99 3.047-1.407 7.12-1.505 10.405-1.223 1.473.126 1.487 2.439 0 2.312z",
    transform: "translate(.885 .5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAssignPending);
export default __webpack_public_path__ + "static/media/icon_assign_pending.622422805679ef00c2624f74a9b708ad.svg";
export { ForwardRef as ReactComponent };